var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"b-row"},[(!_vm.noLabels)?_c('b-col',{attrs:{"cols":"3"}},[_c('dd',{staticClass:"b-col"},[_vm._v(" "+_vm._s(_vm.xi18n(_vm.i8nPrefix, _vm.displayDataField.name))+" ")])]):_vm._e(),_c('b-col',[_c('dt',{staticClass:"b-col"},[_vm._v(_vm._s(_vm.displayDataField.value))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }